import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'


export class VaultTransactionType extends Component { 
    componentDidMount() {
    this.props.selectMode('integration_guide')
    }
  state = {
    isSubmitClicked: false
  };
    render() {
  
      return (
        <div className="stepPageContainer">  
            <h3 className="stepPageTitle">Vault Transaction Types</h3>
            <p>The Vault API supports both administrative and financial transactions.
            </p>   
            <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Administrative Vault Transaction types</h3>  
            <div>
                <b>ResAddCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Creates a new credit card profile, and generates a unique data key which can be obtained
                    from the Receipt object.<br/><br/>
                    This data key is the profile identifier that all future financial Vault transactions will use to associate
                    with the saved information.
                </p>

                <b>EncResAddCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Creates a new credit card profile, but requires the card data to be either swiped or manually
                    keyed in via a Moneris-provided encrypted mag swipe reader.
                </p>

                <b>ResTempAdd</b>
                <p style={{marginLeft:"1vw"}}>
                    Creates a new temporary token credit card profile. This transaction requires a duration to be
                    set to indicate how long the temporary token is to be stored for.<br/><br/>
                    During the lifetime of this temporary token, it may be used for any other vault transaction
                    before it is permanently deleted from the system.
                </p>

                <b>ResUpdateCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Updates a Vault profile (based on the data key) to contain credit card information.<br/><br/>
                    All information contained within a credit card profile is updated as indicated by the submitted
                    fields.
                </p>

                <b>EncResUpdateCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Updates a profile (based on the data key) to contain credit card information. The encrypted
                    version of this transaction requires the card data to either be swiped or manually keyed in via
                    a Moneris-provided encrypted mag swipe reader.
                </p>

                <b>ResDelete</b>
                <p style={{marginLeft:"1vw"}}>
                    Deletes an existing Vault profile of any type using the unique data key that was assigned when
                    the profile was added.
                <br/><br/>
                    It is important to note that after a profile is deleted, the information which was saved within
                    can no longer be retrieved.
                </p>

                <b>ResLookupFull</b>
                <p style={{marginLeft:"1vw"}}>
                    Verifies what is currently saved under the Vault profile associated with the given data key. The
                    response to this transaction returns the latest active data for that profile.
                <br/><br/>
                    Unlike ResLookupMasked (which returns the masked credit card number), this transaction
                    returns both the masked and the unmasked credit card numbers.
                </p>
  
                <b>ResLookupMasked</b>
                <p style={{marginLeft:"1vw"}}>
                    Verifies what is currently saved under the Vault profile associated with the given data key. The
                    response to this transaction returns the latest active data for that profile.
                <br/><br/>
                    Unlike ResLookupFull (which only returns both the masked and the unmasked credit card
                    numbers), this transaction only returns the masked credit card number.
                </p>

                <b>ResGetExpiring</b>
                <p style={{marginLeft:"1vw"}}>
                    Verifies which profiles have credit cards that are expiring during the current and next calendar
                    month. For example, if you are processing this transaction on September 30, then it will
                    return all cards that expire(d) in September and October of this year.
                <br/><br/>
                    When generating a list of profiles with expiring credit cards, only the <b>masked</b> credit card numbers
                    are returned.
                <br/><br/>
                    This transaction can be performed no more than 2 times on any given calendar day, and it
                    only applies to credit card profiles.
                </p>

                
                
                <b>ResIscorporatecard</b>
                <p style={{marginLeft:"1vw"}}>
                    Determines whether a profile has a corporate card registered within it.
                <br/><br/>
                    After sending the transaction, the response field to the Receipt object's getCorporateCard
                    method is either <code>true</code> or <code>false</code> depending on whether the associated card is a corporate
                    card.
                </p>


                <b>ResAddToken</b>
                <p style={{marginLeft:"1vw"}}>
                    Converts a Hosted Tokenization temporary token to a permanent Vault token.
                    <br/><br/>
                    A temporary token is valid for 15 minutes after it is created.
                </p>


                <b>ResTokenizeCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Creates a new credit card profile using the credit card number, expiry date and e-commerce
                    indicator that were submitted in a previous financial transaction. A transaction that was previously
                    done in Moneris Gateway is taken, and the card data from that transaction is stored
                    in the Moneris Vault.
                <br/><br/>
                    As with ResAddCC, a unique data key is generated and returned to the merchant via the
                    Receipt object. This is the profile identifier that all future financial Vault transactions will use to
                    associate with the saved information.
                </p>

                <b>ResPurchaseCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Uses the data key to identify a previously registered credit card profile. The details saved
                    within the profile are then submitted to perform a Purchase transaction.
                </p>


                <b>ResPreauthCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Uses the data key to identify a previously registered credit card profile. The details within the
                    profile are submitted to perform a Pre-Authorization transaction.
                </p>


                <b>ResIndRefundCC</b>
                <p style={{marginLeft:"1vw"}}>
                    Uses the unique data key to identify a previously registered credit card profile, and credits a
                    specified amount to that credit card.
                </p>


                <b>ResMpiTxn</b>
                <p style={{marginLeft:"1vw"}}>
                    Uses the data key (as opposed to a credit card number) in a VBV/SecureCode Txn MPI transaction.
                    The merchant uses the data key with ResMpiTxn request, and then reads the
                    response fields to verify whether the card is enrolled in Verified by Visa or MasterCard
                    SecureCode. Retrieves the vault transaction value to pass on to Visa or MasterCard.
                    <br/><br/>
                    After it has been validated that the data key is is enrolled in 3-D Secure, a window appears in
                    which the customer can enter the 3-D Secure password. The merchant may initiate the forming
                    of the validation form <code>getMpiInLineForm()</code><br/><br/>
                    For more information on integrating with MonerisMPI, refer to 1 MPI.
                </p>
                <h3 className="stepPageTitle">Vault Administrative Transactions</h3>
                    <p>Administrative transactions allow you to perform such tasks as creating new Vault profiles, deleting existing
                    Vault profiles and updating profile information.</p>
                    <p>Some Vault Administrative Transactions require the Credential on File object to be sent with the <b>issuer ID</b>
                    field only.</p>
            </div>
        </div>
        )
    }
}



const mapStateToProps = state => {
    const {mode} = state.common.sideNav;
    return { mode};
  }
  
  export default connect(mapStateToProps, { selectMode})(VaultTransactionType)
  
  
  